import type { ApiContext } from "@/api/types";
import { getGroupAuthType } from "@/utils/authToken";
import { GROUP_AUTH_HEADER_NAME } from "@/api/constants";
import { httpAuth2 } from "@/api/auth";
import type { PatientConsent, PatientStatus, UUID } from "@/core/types";

type UpdatePatientStatusPayload = {
  providerName?: string;
  reason?: string;
  status: PatientStatus;
  username: UUID;
};

export type UpdatePatientStatusResponse = {
  previous_status: PatientStatus;
};

export const providerRequestsTyped = {
  get_patient_consents: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: UUID;
  }) {
    return httpAuth2
      .post(`/v1/patient_management/${patientId}/get_latest_consents`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      })
      .json<PatientConsent[]>();
  },

  update_patient_status: function ({
    context,
    data,
    patientId,
  }: {
    context?: ApiContext;
    data: UpdatePatientStatusPayload;
    patientId: UUID;
  }) {
    return httpAuth2
      .post(`/v1/patient_management/${patientId}/update_patient_details`, {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json<UpdatePatientStatusResponse>();
  },
};
